import React from 'react'
import {withFormImageInput, FileInput} from 'startlibs/lib/form'
import {ice} from 'icepath'
import {defaultMemoize} from 'reselect'

@withFormImageInput(
  function preValidate(file) {
    if (file.size > 2097152) {
      return ['Your file needs to be smaller than 2mb.']
    }
    if (['image/gif', 'image/png', 'image/jpeg', 'image/jpg'].indexOf(file.type.toLowerCase()) < 0) {
      return ['Invalid file format. Please select a .JPG or .PNG file.']
    }
  },
  function uploadFetcher(file, props) {
    const formData = new FormData()
    formData.append('file', file)
    return props.uploadFetcher(formData).then(({resourceUID}) => ({image: resourceUID, uploadStatus: 'upload-finished'}))
  }
)
export class ImageUpload extends React.Component {
  state = {}

  handleDrag = (e) => {
    e.preventDefault()
    e.dataTransfer.dropEffect = 'copy'
    this.setState({isDragging: true})
  }

  setDragRef = (el) => {
    if (el) {
      el.addEventListener('dragover', this.handleDrag)
      el.addEventListener('dragenter', this.handleDrag)
    }
  }

  handleDragLeave = () => this.setState({isDragging: false})

  handleDrop = (e) => {
    const {handleFile} = this.props
    e.preventDefault()
    const files = (e.nativeEvent.dataTransfer || e.nativeEvent.target).files
    if (files.length > 0) {
      const file = files[0]
      handleFile(file)
    }
    this.setState({isDragging: false})
  }

  memoizedBackground = defaultMemoize((i)=> (typeof i === "string" ? `url("${this.props.getResource(i)}")` : `url("${URL.createObjectURL(i)}")`))

  getImage = () => ice.get(this.props.form.properties,this.props.path)

  getBackground = () => this.getImage() && !this.state.isDragging ? ({backgroundImage: this.memoizedBackground(this.getImage())}) : {}

  render() {
    const {label,form, path, boxText} = this.props
    const {isDragging} = this.state
    const uploadStatus = ice.get(form.meta, ice.toPath(path).concat('uploadStatus'))
    const uploading = uploadStatus === 'loading'
    const imageClass = isDragging ? ' dragging' : ''
    return (
      <div
        className={'drag-and-drop-image-area' + imageClass}
        ref={this.setDragRef}
        onDragLeave={this.handleDragLeave}
        onDrop={this.handleDrop}
        style={uploading ? {} : this.getBackground()}
      >
        {
          !this.getImage() && !uploading && !isDragging &&
          <span className="drag-and-drop-image-instruction">
            {boxText}
          </span>
        }
        {
          uploading && !isDragging &&
          <span className="drag-and-drop-image-instruction"><span
            className="loader"/><strong>Uploading Image</strong></span>
        }
        {
          isDragging &&
          <span className="drag-and-drop-image-instruction">
            Drop your image here to upload it
          </span>
        }

        <FileInput onChange={this.handleDrop}/>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./~/report-components/src/components/imageUpload.js